// Configuration - Auto-generated by deploy-frontend.sh
// STACK: IdpDemoStack
const CONFIG = {
  userPoolId: "ap-southeast-2_idA36wZ2B",
  userPoolClientId: "2dkul55pp1v6q8ro36mnu6va9e",
  region: "ap-southeast-2",
  apiUrl: "https://62ffyqf9xc.execute-api.ap-southeast-2.amazonaws.com/prod/",
  uploadBucketName: "idpdemostack-documentuploadbucket83dcdbd6-iyvlhgkm6h1p",

  // Midway Auth
  midwayEnabled: true,
  cognitoDomain: "idp-demo-279922177625.auth.ap-southeast-2.amazoncognito.com",
  callbackPath: "/",
};

export default CONFIG;
